import httpClient from './httpClient'

const END_POINT = '/pois?limit=true'

const getPois = () => httpClient.get(END_POINT)

const getPoisPaginated = (page, perPage, pointOfInterestType) => {
  let url = `/pois?paginate=true&page=${page}&perPage=${perPage}`
  if (pointOfInterestType) url += `&pointOfInterestType=${pointOfInterestType}`
  return httpClient.get(url)
}

export { getPois, getPoisPaginated }
